import $ from 'jquery';
import Swal from 'sweetalert2';
import 'moment';
import 'daterangepicker';
import croppie from 'croppie';
import { recaptchaUpdater } from '../../modules/recaptcha';
import { dateRange } from '../../modules/dateRange';

import {
  unity,
  stores,
  categories,
  plurals,
  organizations,
  unityParticipant,
  storesParticipant,
  stateCity,
} from '../../modules/select';

import { quillEditor } from '../../modules/quillEditor';

Dropzone.autoDiscover = false;
import 'dropzone';

const settings = {
  _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
};

const dropzone = () => {
  if (document.getElementById('myDropzone')) {
    Dropzone.autoDiscover = false;
    var token = $('meta[name="csrf-token"]').attr('content');

    new Dropzone('#myDropzone', {
      url: window.location.origin + '/acoes-disponiveis/materiais/upload-arquivos',
      paramName: 'gallery',
      maxFilesize: 10,
      maxFiles: 50,
      acceptedFiles:
        'image/*,application/pdf,video/mp4,video/m4a,application/msword,application/zip,application/x-7z-compressed,application/vnd.ms-excel,application/x-rar-compressed,text/csv,application/x-tar,application/vnd.ms-powerpoint,video/x-msvideo',
      previewTemplate: document.querySelector('#tpl').innerHTML,
      params: {
        _token: token,
        challenge_id: $('[name="id"]').val(),
      },
      addRemoveLinks: true,
      dictDefaultMessage: 'Selecione as imagens que deseja enviar',
      dictCancelUpload: 'Cancelar o envio',
      dictRemoveFile: 'Remover',
      dictMaxFilesExceeded: 'Você já adicionou uma foto',
      dictFileTooBig: 'Arquivo muito grande',
      dictInvalidFileType: 'Este arquivo não é uma imagem',
      init: function () {
        this.on('success', function (file, response) {
          $('.added_photos').append(
            '<input type="hidden" data-name="' + file.name + '" name="gallery[]" value="' + response + '"/>'
          );

          let $item = $('<input type="hidden" data-name="' + file.name + '" name="material_name[]"/>');
          $('.added_photos').append($item);

          $(file.previewElement.querySelector('[data-item-name]')).on('keyup', function (e) {
            $item[0].value = e.target.value;
          });
        });
        this.on('removedfile', function (file, response) {
          $("input[name='gallery[]'], input[name='material_name[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    });
  }
};

const crop = () => {
  let crop;
  const $uploadCrop = document.getElementById('upload-crop');
  const $modalCrop = document.getElementById('modal-crop');
  const $inputImg = document.querySelector('.js-challenge-cover');

  $inputImg.addEventListener('change', function () {
    var reader = new FileReader();
    reader.onload = function (e) {
      crop = new croppie($uploadCrop, {
        enableExif: true,
        viewport: {
          width: 256,
          height: 170,
        },
        boundary: {
          width: 300,
          height: 200,
        },
      });

      crop
        .bind({
          url: e.target.result,
        })
        .then(function () {
          $modalCrop.classList.add('is-active');
        });
    };
    reader.readAsDataURL(this.files[0]);
  });

  $('.js-crop-challenge').on('click', function (e) {
    e.preventDefault();

    crop
      .result({
        type: 'canvas',
        size: { width: 512, height: 340 },
        format: 'jpeg',
        quality: 0.6,
      })
      .then(function (resp) {
        $('#cover_chosen').attr('src', resp);
        $('[name="cover"]').val(resp);
        $('#modal-crop').removeClass('is-active');
        setTimeout(() => {
          crop.destroy();
          $inputImg.value = '';
        }, 300);
      });
  });

  $('.js-crop-cancel').on('click', function () {
    document.getElementById('modal-crop').classList.remove('is-active');

    setTimeout(() => {
      crop.destroy();
    }, 300);
  });

  $('.js-thumb').on('click', function () {
    document.getElementById('cover_chosen').src = $(this).attr('src');
    document.getElementById('cover_url').value = $(this).attr('src');
    document.querySelector('[name="cover"]').value = '';
  });
};

const geoAutocomplete = () => {
  let interval = setInterval(() => {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      initAutocomplete();
    }
  }, 200);

  let placeSearch, autocomplete;
  let componentForm = {
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'short_name',
  };

  function initAutocomplete() {
    clearInterval(interval);

    // Create the autocomplete object, restricting the search to geographical
    // location types.
    autocomplete = new google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */ (document.getElementById('autocomplete')),
      { types: ['geocode'] }
    );

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener('place_changed', fillInAddress);
  }

  function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();

    for (var component in componentForm) {
      document.getElementById(component).value = '';
      document.getElementById(component).disabled = false;
    }

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (componentForm[addressType]) {
        var val = place.address_components[i][componentForm[addressType]];
        document.getElementById(addressType).value = val;
      }
    }
  }

  $('[data-geolocate]').on('focus', geolocate());

  // Bias the autocomplete object to the user's geographical location,
  // as supplied by the browser's 'navigator.geolocation' object.
  function geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        var circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy,
        });
        autocomplete.setBounds(circle.getBounds());
      });
    }
  }
};

const bindActions = () => {
  $('input[name="location"]').on('change', function () {
    $('[data-location').hide();
    $('[data-location="' + $(this).val() + '"]').show();
  });

  $('.continue').on('click', function (e) {
    e.preventDefault();

    let currentSlide = $(this).attr('data-current');
    let nextSlide = $(this).attr('data-next');

    if (currentSlide == 'first') {
      let checkActivity = false;
      $('.js-activity').each(function (i, el) {
        if ($(el).is(':checked')) {
          checkActivity = true;
          return false;
        }
      });

      if (
        $("input[name='title']").val() == '' ||
        !checkActivity ||
        $("input[name='is_limited']:checked").val() == null ||
        ($("input[name='is_limited']:checked").val() == 1 && $("input[name='vacancies']").val() == '') ||
        !window.quillEditors
          .find(el => el.id === 'quill-description')
          ?.quill.getText()
          .trim().length
      ) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if ($("input[name='title']").val() == '' || !checkActivity) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    if (currentSlide == 'organization') {
      // Usuário Tipo Loja
      if (['employee', 'external'].includes($('[name="user_type"]').val())) {
        // Se existe input de local da ação
        if ($('input[name="location"]').length) {
          if (!$('input[name="location"]:checked').length) {
            Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
            return false;
          }
        }

        if ($('[data-location="organization"]').is(':visible')) {
          if ($('.js-organization').val() == 0) {
            Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
            return false;
          }
          if ($('.js-organization').val() == 'outro') {
            if (
              $('.js-organization-type option:selected').val() == '' ||
              ($('.js-organization-type option:selected').val() == '1' &&
                $("input[name='school_name']").val() == '') ||
              ($('.js-organization-type option:selected').val() == '2' &&
                $("input[name='organization_name']").val() == '') ||
              ($('.js-organization-type option:selected').val() == '6' &&
                $("input[name='collective_name']").val() == '') ||
              ($('.js-organization-type option:selected').val() == '7' &&
                $("input[name='socialproject_name']").val() == '')
            ) {
              Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
              return false;
            }
          }
        }

        if ($('[data-location="store"]').is(':visible')) {
          if ($('.js-unities').val() == '' || !$('.js-unities').val()) {
            Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
            return false;
          }

          if ($('.js-stores').val() == '' || !$('.js-stores').val()) {
            Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
            return false;
          }
        }
      }

      if ($('input[name="type"]:checked').length == 0) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      // Se ação for presencial ou híbrida
      if (['present', 'hybrid'].includes($('[name="type"]:checked').val())) {
        if (
          $("[name='school_address']").val() == '' ||
          $('[name="state_id"]').val() == '' ||
          $('[name="city_id"]').val() == ''
        ) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (
        $('[name="organization_type_id"]').is(':visible') &&
        $('[name="organization_type_id"]').val() == ''
      ) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if ($('[name="school_name"]').is(':visible') && $('[name="school_name"]').val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if ($('[name="organization_name"]').is(':visible') && $('[name="organization_name"]').val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if ($('[name="public_name"]').is(':visible') && $('[name="public_name"]').val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if ($('[name="cnpj"]').is(':visible') && $('[name="cnpj"]').val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if (
        $('[name="multi_organization_name[1]"]').is(':visible') &&
        $('[name="multi_organization_name[1]"]').val() == ''
      ) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      if (
        $('[name="multi_organization_cnpj[1]"]').is(':visible') &&
        $('[name="multi_organization_cnpj[1]"]').val() == ''
      ) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    if (currentSlide == 'due_date') {
      if ($("input[name='calendar']").val() == '' || $('#time_start_at').val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    if (currentSlide == 'materials') {
      if ($('[name="material_name[]"]').length) {
        for (let $i = 0; $i < $('[name="material_name[]"]').length; $i++) {
          let $el = $('[name="material_name[]"]')[$i];
          if (!$el.value.length) {
            Swal.fire('Atenção!', 'Preencha o nome dos materiais', 'error');
            return false;
          }
        }
      }
    }

    if (currentSlide == 'plural') {
      if ($('.js-plural').val() == '' || $('.js-category').val() == '') {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    if (currentSlide == 'stores') {
      if (
        $("select[name='unities_selected_id']").val() == '' ||
        $("select[name='stores_participant_id[]']").val() == ''
      ) {
        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }
    }

    $('.publish-challenge').on('click', function (e) {
      e.preventDefault();
      document.body.classList.add('loading-active');

      if ($('#cover_url').val() == '' && $('[name="cover"]').val() == '') {
        document.body.classList.remove('loading-active');

        Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
        return false;
      }

      $('.form-signin').submit();
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });

    $('#' + currentSlide).removeClass('active');
    $('#' + nextSlide).addClass('active');
  });

  $('.back').on('click', function (e) {
    e.preventDefault();

    let currentSlide = $(this).attr('data-current');
    let nextSlide = $(this).attr('data-next');

    window.scrollTo({ top: 0, behavior: 'smooth' });

    $('#' + currentSlide).removeClass('active');
    $('#' + nextSlide).addClass('active');
  });

  $('.js-limited').on('change', function () {
    if ($("input[name='is_limited']:checked").val() == '1') {
      $('#js-vacancies--total').removeClass('u-display--none');
    } else {
      $('#js-vacancies--total').addClass('u-display--none');
    }
  });

  const hideAll = () => {
    $('#c-school').addClass('u-display--none');
    $('#c-school input[name="school_name"]').val('');
    $('#c-school input[name="inep"]').val('');
    $('#c-school input[name="register_number"]').val('');
    $('#add-cnpj').addClass('u-display--none');
    $('#add-cnpj input[name="cnpj"]').val('');

    $('#c-organization').addClass('u-display--none');
    $('#c-organization input[name="organization_name"]').val('');

    $('#c-public').addClass('u-display--none');
    $('#c-public input[name="public_name"]').val('');

    $('#c-organizationlist').addClass('u-display--none');
    $('.js-organizationlist').val('');

    $('input[name="school_address"]').val('');
    $('input[name="multi_organization_name[1]"]').val('');
    $('input[name="multi_organization_cnpj[1]"]').val('');
    $('input[name="multi_organization_social_object[1]"]').val('');

    $('#add-social-object').addClass('u-display--none');
    $('#add-social-object input[name="social-object"]').val('');

    $('#contact-organization').addClass('u-display--none');
    $('#contact-organization input').val('');

    let num = $('.js-add-organization').attr('data-count');
    if (num > 1) {
      for (i = 2; i <= num; i++) {
        $('#organization-id-' + i).remove();
      }
    }
  };

  $("#c-type input[name='type']").on('change', () => {
    $('#s-organization').removeClass('u-display--none');
  });

  $('.js-organization').on('change', function () {
    let type = $("input[name='type']:checked").val();

    if (this.value == 1) {
      hideAll();
      $('#c-school').removeClass('u-display--none');
      $('#add-cnpj').removeClass('u-display--none');
      $('#contact-organization').removeClass('u-display--none');
      $('#label-cnpj').html('CNPJ / INEP / Nº de registro *');
      $('#input-cnpj').attr('placeholder', 'CNPJ / INEP / Nº de registro *');
    } else if (this.value == 2) {
      hideAll();
      $('#c-organization').removeClass('u-display--none');
      $('#add-cnpj').removeClass('u-display--none');
      $('#contact-organization').removeClass('u-display--none');
      $('#add-social-object').removeClass('u-display--none');
      $('#label-cnpj').html('CNPJ*');
      $('#input-cnpj').attr('placeholder', 'CNPJ*');
    } else if (this.value == 3) {
      hideAll();
      $('#c-public').removeClass('u-display--none');
      $('#contact-organization').removeClass('u-display--none');
    } else if (this.value == 4) {
      hideAll();
    } else if (this.value == 5) {
      hideAll();
      $('#c-organizationlist').removeClass('u-display--none');
    } else if (this.value == 8) {
      hideAll();
      $('#add-cnpj').removeClass('u-display--none');
      $('#label-cnpj').html('CNPJ*');
    } else {
      hideAll();
    }
  });

  $(document).on('click', '.js-add-organization', function (e) {
    e.preventDefault();

    let num = parseInt($(this).attr('data-count')) + 1;

    let template = `
          <div class="o-card u-m-t-30" id="organization-id-${num}">
            <label class="u-m-t-15">Nome da organização*</label>
            <input type="text" class="form-control" name="multi_organization_name[${num}]" placeholder="Nome da organização" maxlength="80">
            
            <label class="u-m-t-15">CNPJ*</label>
            <input type="text" class="form-control js-form-cnpj" name="multi_organization_cnpj[${num}]" placeholder="CNPJ da organização" maxlength="20" >

            <div class="o-card--button">
              <button class="o-btn o-btn--danger js-drop-organization u-m-t-15" data-id="organization-id-${num}"><i class="fa fa-trash"></i> Remover</button>
            </div>
          </div>`;

    $('.s-challenges--create-grid').append(template);

    $(this).attr('data-count', num);
  });

  $(document).on('click', '.js-drop-organization', function (e) {
    e.preventDefault();
    $('#' + $(this).attr('data-id')).remove();
  });

  $('[name="type"]').on('change', function () {
    if (['present', 'hybrid'].includes($(this).val())) {
      $('.u-label-asterisk[data-type]').addClass('active');
    } else {
      $('.u-label-asterisk[data-type]').removeClass('active');
    }
  });
};

const organizationsLogic = () => {
  var post = {};
  post._token = $('meta[name="csrf-token"]').attr('content');

  const organization_selected = document.querySelector('.js-organization').value;

  if (organization_selected && organization_selected !== 'outro') {
    showOrganizationFields();
    getOrganizationLocation(organization_selected);
  } else {
    $('.js-organization-type-container').hide();
    $('.js-organization-block-info').hide();
    $('.js-org-container').show();
    $('.js-org-address-container').show();
  }

  $('.js-organization').on('change', function () {
    cleanFields();
    if (this.value == 'outro') {
      showOtherOrganizationFields();
    } else {
      showOrganizationFields();
      getOrganizationLocation($(this).val());
    }
  });

  function showOrganizationFields() {
    $('.js-org-address-container').show();
    $('.js-organization-block-info').show();
    $('.js-organization-type-container').hide();
    $('.js-org-container').hide();
  }

  function showOtherOrganizationFields() {
    $('.js-organization-type-container').show();
    $('.js-organization-block-info').hide();
    $('.js-org-address-container').hide();
  }

  function getOrganizationLocation(id) {
    $.ajax({
      type: 'POST',
      data: post,
      url: window.location.origin + '/organizacao/' + id,
      success: function (data) {
        if (data.success) {
          $('#organization_city').val(data.city);
          $('#organization_state').val(data.state);
          $('#organization_unity').val(data.unity);
        }
      },
    });
  }

  function cleanFields() {
    $('#organization_city').val('');
    $('#organization_state').val('');
    $('#organization_unity').val('');
    $('.js-org-name-input').val('');
    $('.js-org-address').val('');
    $('.js-organization-type').val('');
  }
};

const organizationStoreLogic = () => {
  const $organization_type = document.querySelector('.js-organization-type'),
    $orgNameLabel = document.querySelector('.js-org-name-label'),
    $orgNameInput = document.querySelector('.js-org-name-input'),
    $orgContainer = document.querySelector('.js-org-container'),
    $orgAddressContainer = document.querySelector('.js-org-address-container'),
    $orgAddress = document.querySelector('.js-org-address'),
    arrTypes = {
      1: {
        name: 'Escola ou creche',
        label: 'Nome da Escola/Creche*',
        propName: 'school_name',
      },
      2: {
        name: 'Organização social',
        label: 'Nome da organização social*',
        propName: 'organization_name',
      },
      6: {
        name: 'Coletivo',
        label: 'Nome do Coletivo*',
        propName: 'collective_name',
      },
      7: {
        name: 'Projeto social',
        label: 'Nome do Projeto Social*',
        propName: 'socialproject_name',
      },
    };

  for (let key in arrTypes) {
    let opt = arrTypes[key];
    let el = document.createElement('option');
    el.textContent = opt.name;
    el.value = key;
    if ($organization_type.getAttribute('data-selected') == key) {
      el.setAttribute('selected', 'selected');
    }
    $organization_type.appendChild(el);
  }

  $organization_type.addEventListener('change', function (e) {
    if (this.value !== 0 && this.value.length > 0) {
      $orgAddressContainer.style.display = 'block';
      $orgContainer.style.display = 'block';
      $orgNameLabel.setAttribute('for', arrTypes[this.value].propName);
      $orgNameLabel.textContent = arrTypes[this.value].label;

      $orgNameInput.setAttribute('placeholder', arrTypes[this.value].label);
      $orgNameInput.setAttribute('name', arrTypes[this.value].propName);
      $orgNameInput.setAttribute('id', arrTypes[this.value].propName);
    } else if (document.body.getAttribute('data-action').includes('create')) {
      $orgContainer.style.display = 'none';
      $orgNameInput.value = '';
      $orgAddress.value = '';
    }
  });

  $organization_type.dispatchEvent(new Event('change'));
};

export const _form = () => {
  quillEditor();
  recaptchaUpdater('challenge');
  bindActions();
  dropzone();
  crop();
  dateRange();
  geoAutocomplete();
  unity();
  stores();
  unityParticipant();
  storesParticipant();
  categories();
  plurals();
  organizations();
  organizationsLogic();
  stateCity();

  const user_type = document.querySelector('[name="user_type"]').value;

  if (!['ec', 'cd'].includes(user_type)) {
    organizationStoreLogic();
  }
};
